/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  /*
  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
  */

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

$(document).ready(function(){
  $('.image-popup-vertical-fit').magnificPopup({
  	type: 'image',
    mainClass: 'mfp-with-zoom', 
    gallery:{
    			enabled:true
    		},
    
      zoom: {
        enabled: true, 
    
        duration: 300, // duration of the effect, in milliseconds
        easing: 'ease-in-out', // CSS transition easing function
    
        opener: function(openerElement) {
    
          return openerElement.is('img') ? openerElement : openerElement.find('img');
      }
    }
  
  });

});

$(window).on('load',function(){
   console.log('window loaded');
    var discountTiers = [];
    setTimeout(function() {
      $('#quantity-discount-app .heading.box_wrapper h3').text('Tiered Pricing');
      $('#quantity-discount-app .spec_offer_item_wrapper').each(function(i, obj) {
        var qtyTier = $(this).find('.left_content .spec_text span').eq(0).text();
        var priceTier = $(this).find('.right_content .new_price').text();
        var data = {};
        data.qtyTier = qtyTier;
        data.priceTier = priceTier;
        discountTiers.push(data);
      });
      $('.quantity__input[name="quantity"]').trigger('change');
      console.log(discountTiers);
    }, 1000);  
    
   $('.quantity__input[name="quantity"]').on('change keydown paste input', function() {
    console.log( this.value );
    var quantity = parseInt(this.value);
    $('[custom-product-quantity]').text(this.value);

    console.log(discountTiers);
    let isTierPrice = true;
    var matchedQtyTier = 1;
    var originalPrice = $('[custom-product-price]').data('price'); 
    var priceTier = originalPrice;

    if(discountTiers.length > 0){
      isTierPrice = false;
      
      for(var i = 0; i < discountTiers.length; i++){
        var currentQty = parseInt(discountTiers[i]['qtyTier']);
        var nextQty = (i + 1 < discountTiers.length) ? parseInt(discountTiers[i + 1]['qtyTier']) : Infinity;
        
        if(quantity >= currentQty && quantity < nextQty){
          priceTier = discountTiers[i]['priceTier'];
          matchedQtyTier = currentQty;
          isTierPrice = true;
          break;
        }
      }
    }else{
      isTierPrice = false;
    }

    console.log('priceTier', priceTier);
    console.log('isTierPrice', isTierPrice);
    console.log('matchedQtyTier', matchedQtyTier);

    if(isTierPrice) {
      
      var priceTierCents = priceTier.replace("$", "").replace(",", "") * 100;
      
    
      var perItemPrice = priceTierCents;
      console.log('perItemPrice (cents)', perItemPrice);
      
      
      $('[custom-product-price]').text(Shopify.formatMoney(perItemPrice));
      
      var discountPrice = quantity * perItemPrice;
      $('[custom-subtotal]').text(Shopify.formatMoney(discountPrice));
    } else {
      $('[custom-product-price]').text(originalPrice);
      
      var originalPriceCents;
      if(typeof originalPrice === 'string') {
        originalPriceCents = originalPrice.replace("$", "").replace(",", "") * 100;
      } else {
        originalPriceCents = originalPrice * 100;
      }
      
      var discountPrice = quantity * originalPriceCents;
      $('[custom-subtotal]').text(Shopify.formatMoney(discountPrice));
    }

    changeAddonTotalPrice();
  });
});

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
  cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) {
          return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
      case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
      case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
      case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
  }
  return formatString.replace(placeholderRegex, value);
};

function changeAddonTotalPrice(){
  console.log('change Addon Total Price');
  var qty = $('.quantity__input[name="quantity"]').val();
  var addonPrice = $('.gpo-total-text span.money').text();
  addonPrice = addonPrice.replace("$", "").replace(",", "");
  addonPrice = addonPrice * 100;
  console.log(qty);
  console.log(addonPrice);
  var addonTotalPrice = qty * addonPrice;
  console.log(addonTotalPrice);
  if(addonTotalPrice > 0){
    setTimeout(function() {
      $('.total-price-addon').show(); 
      $('.total-price-addon span.money').text(Shopify.formatMoney(addonTotalPrice));
    }, 100);
  }else{
    $('.total-price-addon').hide();
    $('.total-price-addon span.money').text(Shopify.formatMoney(0));
  }
  
  setTimeout(function() {
    var totalDiscountPrice = $('[custom-subtotal]').text();
     totalDiscountPrice = totalDiscountPrice.replace("$", "").replace(",", "");
     totalDiscountPrice = totalDiscountPrice * 100;
    var estimatePrice = totalDiscountPrice + addonTotalPrice;
    console.log(estimatePrice);
     $('.atc-total-price').text(Shopify.formatMoney(estimatePrice));
  }, 200);
}

document.addEventListener("gpoRenderCompleted", function() {
  console.log('gpoRenderCompleted');
  $('.gpo-element input[type="radio"]').click(function(){
    changeAddonTotalPrice();
  });
});  



